import { Box } from '@mui/material';
import { gray } from '../../theme/themePrimitives';
import LinkEventComponent from './link_card_component';
import { RootState } from '../../redux/store';
import TabsHeader from './tabs_header';
import { useSelector } from 'react-redux';
import { useState } from 'react';

const CalendarLinksComponent = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [sort, setSort] = useState<boolean>(false);
    const { events } = useSelector((state: RootState) => state.calendar);


    // Filter events
    const filteredEvents = events.filter((item) => item.type === 'link' && item?.event_name?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <Box borderTop={`1px solid ${gray[100]}`} minHeight="80vh">
            {/* Header */}
            <TabsHeader searchQuery={searchQuery} setSearchQuery={setSearchQuery} sort={sort} setSort={(value: boolean) => setSort(value)} />

            {/* Events List */}
            <Box display="flex" justifyContent="start" flexWrap="wrap" gap="10px">
                {filteredEvents.map((event, index) => (
                    <Box
                        key={index}
                        minWidth="24.5%"
                        maxWidth="24.5%"
                    >
                        <LinkEventComponent event={event} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default CalendarLinksComponent;